import { render, staticRenderFns } from "./form-design.vue?vue&type=template&id=3990d9f5&scoped=true&"
import script from "./form-design.vue?vue&type=script&lang=js&"
export * from "./form-design.vue?vue&type=script&lang=js&"
import style0 from "./form-design.vue?vue&type=style&index=0&id=3990d9f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3990d9f5",
  null
  
)

component.options.__file = "form-design.vue"
export default component.exports